// Resolve all bundled profile icons at build time so a bad or legacy value
// falls back gracefully instead of throwing error
const PROFILE_ICONS = require.context(
  "../assets/profile_icons_new",
  false,
  /\.svg$/
);

export const DEFAULT_PROFILE_ICON = "27.svg";

/**
 * Resolve a profile-icon value to a bundled asset URL.
 */
export const resolveProfileIcon = profileIcon => {
  if (!profileIcon) return null;

  const fileName = String(profileIcon).endsWith(".svg")
    ? profileIcon
    : `${profileIcon}.svg`;
  const key = `./${fileName}`;

  return PROFILE_ICONS.keys().includes(key)
    ? PROFILE_ICONS(key)
    : PROFILE_ICONS(`./${DEFAULT_PROFILE_ICON}`);
};
